import React, { useEffect, useState, createRef } from "react";
import { useForm } from "react-hook-form";
import { withRouter } from "react-router-dom";
import { Multiselect } from "multiselect-react-dropdown";
import { useSelector } from "react-redux";
import DatePicker from "react-datepicker";
import ssrsService from "../services/ssrs-service";
import orderService from "../services/new-order-service";
import facilityService from "../services/facility-service";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";
import moment from "moment";
import cogoToast from "cogo-toast";
import { selectUsers } from "../state/reducers/userSlice";
import "react-datepicker/dist/react-datepicker.css";
export function CustomSelector({
  id,
  patId,
  setPatId,
  getPatients,
  patientList,
}) {
  const multiselectRefPatient = createRef();

  return (
    <Multiselect
      name="patientList"
      displayValue="fname"
      placeholder="Select Patient"
      selectedValues={patId}
      options={patientList}
      ref={multiselectRefPatient}
      avoidHighlightFirstOption={true}
      selectionLimit={1}
      hidePlaceholder={true}
      onSelect={(selectedList, selectedItem) => {
        setPatId([selectedItem]);
      }}
      onRemove={() => {
        setPatId([]);
      }}
    />
  );
}
export function CustomDatePicker({ id, obj, setObj }) {
  const [date, setDate] = useState(null);
  const handleDate = (val) => {
    setDate(val);
    var test = obj;
    test[id] = val;
    setObj(test);
  };
  return (
    <DatePicker
      placeholderText="Select Date"
      selected={date}
      id={id}
      key={id}
      name={id}
      onChange={(date) => handleDate(date)}
      className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm"
    />
  );
}

const SsrsRep = ({ argumnts, onCloseRepModal }) => {
  const downloadFormats = {
    PDF: "PDF",
    EXCEL: "EXCEL",
  };

  const { register, handleSubmit, errors } = useForm({});
  const [obj, setObj] = useState({});
  const [loading, setLoading] = useState(false);
  const [facList, setFacList] = useState([]);
  const [format, setFormat] = useState(downloadFormats.EXCEL);
  const { user } = useSelector(selectUsers);
  const [patId, setPatId] = useState([]);
    useEffect(() => {
    setLoading(false);
    getFacilities();
    return function cleanup() {
      setObj({});
    };
  }, []);
  const getPatients = async (id) => {
    try {
      let response = await orderService.getPatientsByFacID(id);
      let pList = response?.map((item) => {
        let mname = item.mname ? item.mname : "";
        item.fname = item.fname + " " + mname + " " + item.lname;
        return item;
      });
      setPatientList([]);
      setPatientList(pList);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error retrieving patients. Please contact administrator.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };
  const [cusError, setCusError] = useState(false);
  const submitSsrsReport = async (data) => {
    var notes = "";
    try {
      argumnts.notes.split("&").forEach((item) => {
        if (item.endsWith("DATE")) {
          notes +=
            item + "=" +( obj[item]
              ? moment(obj[item]).format("YYYY-MM-DD")
              : undefined);
        } else if (item.endsWith("DBF_TYPE")) {
          notes += item + "=" + user?.userType;
        } else if (item.endsWith("DBF_ROLE")) {
          notes += item + "=" + user?.userRole;
        } else if (item.endsWith("DBF_DEPARTMENT")) {
          notes += item + "=" + user?.department;
        } else if (item.includes("DBF_PAT_ID")) {
          notes += item + "=" + patId[0]?.id;
        } else if (item.includes("DRG_ID")) {
          notes += item + "=" + drg_name[0]?.id;
        } else if (item.includes("DBF_FAC_ID")) {
          notes += item + "=" + obj[item];
        } else {
          notes += item + "=" + data[item];
        }

        notes = notes + "&";
      });
      if (notes.includes("undefined")) {
        setCusError(true);
        return;
      }

      const payload = { type: format, data: notes?.substring(0,notes?.length-1), id: argumnts.id };

      setLoading(true);
      let fileName = format === downloadFormats.PDF ? "report.pdf" :  "report.xlsx";
      await ssrsService.generateSsrsFile(payload, fileName );
      setLoading(false);
      onCloseRepModal(true);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error generating report. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
  };
  const [facStr, setFacStr] = useState("");
  const [drg_name, setDrugName] = useState([]);
  const [drgList, setDrugList] = useState([]);
  const multiselectRefDrug = createRef();

  async function getFacilities(parentId) {
    try {
      setLoading(true);
      let userFacilities = await facilityService.getFacilityById(user?.userId);
      if (userFacilities) {
        setFacList(userFacilities);
        setFacStr(userFacilities.map((item) => item.id).join(","));
      }
      setLoading(false);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error while getting facilities details. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
  }
  const [patientList, setPatientList] = useState([]);

  const generateUI = () => {
    return argumnts.notes.split("&").map((item, i) => (
      <>
        {item.endsWith("DATE") && (
          <li  key={i} className={`inline-block pt-2 text-sm leading-8 w-full`}>
            <label> {item}</label>
            <span className="text-xs md:text-sm text-hlred ml-1">*</span>
            <CustomDatePicker id={item} obj={obj} setObj={setObj} />
            {cusError && obj[item] === undefined && (
              <p className="text-xs md:text-sm md:pt-1 text-hlred table">
                You must specify date
              </p>
            )}
          </li>
        )}
        {item.endsWith("ID") &&
          !item.includes("DBF") &&
          !item.includes("DRG_ID") && (
            <li  key={i} className={`inline-block pt-2 text-sm leading-8 w-full`}>
              <label> {item}</label>
              <span className="text-xs md:text-sm text-hlred ml-1">*</span>
              <input
                id={item}
                name={item}
                type="number"
                placeholder={`Enter ${item}`}
                autoComplete=""
                ref={register({
                  required: "You must specify the " + { item },
                })}
                className="text-fogotpwsd_login placeholder-fogotpwsd_login font-semibold border focus:outline-none h-10 rounded-md pl-3 text-sm font-normal w-full"
              />
              {errors && errors[item] === undefined && (
                <p className="text-xs md:text-sm md:pt-1 text-hlred table">
                  You must specify value
                </p>
              )}
            </li>
          )}
        {!item.endsWith("ID") &&
          !item.endsWith("DATE") &&
          !item.endsWith("DRG_ID") &&
          !item.includes("DBF") && (
            <li  key={i} className={`inline-block pt-2 text-sm leading-8 w-full`}>
              <label> {item}</label>
              <span className="text-xs md:text-sm text-hlred ml-1">*</span>
              <input
                id={item}
                name={item}
                type="text"
                placeholder={`Enter ${item}`}
                autoComplete=""
                ref={register({
                  required: "You must specify the " + { item },
                })}
                className="text-fogotpwsd_login placeholder-fogotpwsd_login font-semibold border focus:outline-none h-10 rounded-md pl-3 text-sm font-normal w-full"
              />
              {errors && errors[item] === undefined && (
                <p className="text-xs md:text-sm md:pt-1 text-hlred table">
                  You must specify value
                </p>
              )}
            </li>
          )}

        {item.startsWith("DBF_FAC_ID") && (
          <li  key={i} className={`inline-block pt-2 text-sm leading-8 w-full`}>
            <label> {item}</label>
            <span className="text-xs md:text-sm text-hlred ml-1">*</span>
            <select
              name={item}
              aria-label="Select Facility"
              id={item}
              onChange={(e) => {
                let objcopy = obj;
                objcopy[item] = e.target.value;
                setObj(objcopy);
              }}
              className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm"
            >
              <option key="Select" value="">Select Facility</option>
              <option key="All" value={facStr}>All</option>

              {facList
                ? facList.map((facility, i) => {
                    return (
                      <option key={i} value={facility.id}>
                        {facility.name}
                      </option>
                    );
                  })
                : null}
            </select>
            {cusError && obj[item] === undefined && (
              <p className="text-xs md:text-sm md:pt-1 text-hlred table">
                You must specify facility
              </p>
            )}
          </li>
        )}
        {item.includes("DBF_PAT_ID") && (
          <li  key={i} className={`inline-block pt-2 text-sm leading-8 w-full`}>
            <label> Select Facility</label>
            <span className="text-xs md:text-sm text-hlred ml-1">*</span>
            <select
              name={item}
              aria-label="Select Facility"
              id={item}
              onChange={(e) => {
                getPatients(e.target.value);
              }}
              className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm"
            >
              <option key="select" value="">Select Facility</option>
              {facList
                ? facList.map((facility, i) => {
                    return (
                      <option key={i} value={facility.id}>
                        {facility.name}
                      </option>
                    );
                  })
                : null}
            </select>
            <div className="pt-4">
            <label> Select Patient</label>
            <span className="text-xs md:text-sm text-hlred ml-1">*</span>
              <CustomSelector
                id={item}
                patId={patId}
                setPatId={setPatId}
                getPatients={getPatients}
                patientList={patientList}
              />
            </div>
            {cusError && patId?.length === 0 && (
              <p className="text-xs md:text-sm md:pt-1 text-hlred table">
                You must specify value
              </p>
            )}
          </li>
        )}
        {item.includes("DRG_ID") && (
          <li  key={i} className={`inline-block pt-2 text-sm leading-8 w-full`}>
            <label> {item}</label>
            <span className="text-xs md:text-sm text-hlred ml-1">*</span>
            <Multiselect
              name="drgList"
              displayValue="dname"
              selectedValues={drg_name}
              options={drgList}
              ref={multiselectRefDrug}
              avoidHighlightFirstOption={true}
              selectionLimit={1}
              hidePlaceholder={true}
              caseSensitiveSearch={true}
              onSelect={(selectedList, selectedItem) => {
                setDrugName([selectedItem]);
              }}
              onSearch={(value) => {
                getDrugList(value);
              }}
              onRemove={() => {
                setDrugName([]);
              }}
            />
            {errors && drg_name?.length === 0 && (
              <p className="text-xs md:text-sm md:pt-1 text-hlred table">
                You must specify drug name
              </p>
            )}
          </li>
        )} 
      </>
    ));
  };

  const getDrugList = async (search) => {
    try {
      let response = await orderService.getDrugs(search);
      let dList = response?.map((item) => {
        item.dname = item.dname + " " + item.strength + " " + item.dos_id;
        return item;
      });

      setDrugList([]);
      setDrugList(dList);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error retrieving drugs. Please contact administrator.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };

  return (
    <>
      <div
        className={`inline-block customtop w-full absolute z-50 ${
          loading ? "show" : "hidden"
        }`}
      >
        <Loader
          type="Oval"
          color="#00BFFF"
          height={50}
          width={50}
          timeout={300000} //3 secs
        />
      </div>
      <div className="text-xl truncate pr-8" title={argumnts.name}>{argumnts.name}</div>
      <div className="bg-white w-full mx-auto mt-2 mb-4 rounded ">
        <div className="p-2 text-xs">
          <form onSubmit={handleSubmit(submitSsrsReport)}>
            <ul>
              {generateUI()}

              <li  key="format" className={`inline-block pt-2 text-sm leading-8 w-full`}>
                <label>Format</label>
                <span className="text-xs md:text-sm text-hlred ml-1">*</span>
                <select
                  name="selectformat"
                  aria-label="Select format"
                  onChange={(e) => setFormat(e.target.value)}
                  value={format}
                  className="border focus:outline-none h-10 rounded-md pl-2 text-sm font-normal w-full"
                >
                  <option key="2" value={downloadFormats.EXCEL}>
                    {downloadFormats.EXCEL}
                  </option>
                  <option key="1" value={downloadFormats.PDF}>
                    {downloadFormats.PDF}
                  </option>
                  
                </select>
              </li>

              <li  key="submit" className="text-center">
                <button
                  disabled={loading}
                  className={
                    loading
                      ? "opacity-50 cursor-not-allowed text-white w-full sm:w-auto h-8 px-6 mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                      : "text-white w-full sm:w-auto h-8 px-6 mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                  }
                >
                  SUBMIT
                </button>
              </li>
            </ul>
          </form>
        </div>
      </div>
    </>
  );
};

export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({}, dispatch);
    }
  )(SsrsRep)
);
